module.exports = __webpack_public_path__ + "static/media/YM59_6.93286c06.jpg";